'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  value: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func.isRequired
};

function SimpleTag(_ref) {
  var onClick = _ref.onClick,
      value = _ref.value,
      special = _ref.special;

  var className = (0, _classnames2.default)('SimpleTag', {
    'is-special': special
  });

  return _react2.default.createElement(
    'span',
    { className: className },
    value,
    _react2.default.createElement(
      'button',
      { onClick: onClick, className: 'SimpleTag__btn' },
      '\xD7'
    )
  );
}

SimpleTag.propTypes = propTypes;

exports.default = SimpleTag;


//////////////////
// WEBPACK FOOTER
// ../lib/SimpleTag.js
// module id = 299
// module chunks = 0